const pageNotFoundRoute = [
  {
    path: "/:pathMatch(.*)*",
    name: "PageNotFound",
    component: () => import("../pages/PageNotFound.vue"),
  },
];

export default pageNotFoundRoute;
